import React from 'react'
import { MoonLoader } from 'react-spinners'

import './style.scss'

const Index = () => {
    return(
        <div className="csv-uploading-loader-container">
            <div className="loader">
                <MoonLoader
                size={40}
                color={"#123abc"}
                loading={true}
                />
            </div>
            <h4 className="loading-label">Laster opp CSV-filen med korrigert datasett, vennligst ikke lukk vinduet.</h4>
        </div>
    )
}

export default Index